import { render, staticRenderFns } from "./PcSlideBanner.vue?vue&type=template&id=3065bdf0"
import script from "./PcSlideBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PcSlideBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PcSlideBanner.vue?vue&type=style&index=0&id=3065bdf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
